import { useEffect } from 'react';

import { matchPath, useLocation } from 'react-router-dom';
import { trackAction } from '../../helpers/trackAction';

type Props = { ignored: string[] };

const ScrollToTop = ({ ignored }: Props) => {
  const location = useLocation();
  useEffect(() => {
    if (location) {
      const { hash, search, pathname, host } = window.location;
      trackAction({
        action_type: 'page_view',
        data: { location: { hash, host, search, pathname } },
      });
    }
  }, [location]);
  useEffect(() => {
    const isIgnored =
      !ignored ||
      ignored.reduce((acc, item) => {
        return (
          acc ||
          !!matchPath(
            { path: item.replace('?', ''), caseSensitive: false, end: false },
            location.pathname,
          )
        );
      }, false as boolean);
    isIgnored || window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
